import { useEffect } from "react";
import axios from "axios";
import { logout } from "./helpCaseService";

export function RefreshToken() {

  useEffect(() => {


    const handleRefresh = async () => {
      const refreshToken = localStorage.getItem("refreshToken");

      if (!refreshToken) {
        return;
      }

      try {
        const patch = process.env.REACT_APP_API_URL;

        const response = await axios.post(
          `${patch}/auth/refresh`,
          {},
          {
            headers: {
              Authorization: `Bearer ${refreshToken}`
            }
          }
        );

        const accessToken = response.data.accessToken;
        const newRefreshToken = response.data.refreshToken;

        localStorage.setItem("token", accessToken);

        if (newRefreshToken) {
          localStorage.setItem("refreshToken", newRefreshToken);
        }

      } catch (error) {
        logout();
        console.error("Erro no refresh automático:", error);
      }
    };

    const interval = setInterval(handleRefresh, 60000);


    return () => clearInterval(interval);
  }, []);

  return null;
}